import { PER_PAGE } from "../../components/constants";
import { CLOSE_LOADER, OPEN_LOADER } from "../actions/appActions";
import { CREATE_NOTIFICATION, NOTIFICATION_LIST, STUDENTS_GROUP_LIST ,RESET_NOTIFICATION_LIST ,GET_MSG_TEMPLATE} from "../actions/notificationAction";
const initialState = {
    notificationsList: [],
    loader: false,
    studentsGroupList:[],
    msgTemplate:null,
    pagination: {
      perPage: PER_PAGE,
      totalItems: 0,
      currentPage: 0,
      totalPages:0
    },
  };
  
  export const notificationReducer = (state=initialState, action) => {
    switch (action.type) {
      case OPEN_LOADER: 
        return {
          ...state,
          loader: action.payload
        }
      case CLOSE_LOADER: 
        return {
          ...state,
          loader: action.payload
        }
        case CREATE_NOTIFICATION:
        return {
          ...state,
          notificationsList:state.notificationsList.concat(action.payload)
        };
        case NOTIFICATION_LIST:
        return {
          ...state,
          notificationsList:state.notificationsList.concat(action.payload.notificationData),
          pagination:{
            totalItems: action.payload.totalItems,
            totalPages: action.payload.totalPages,
            currentPage: action.payload.currentPage,
            perPage:PER_PAGE
          }
        };
        case STUDENTS_GROUP_LIST:
          return {
            ...state,
            studentsGroupList:action.payload
          };
      case RESET_NOTIFICATION_LIST:
        return {
          ...state,
          notificationsList: action.payload,
          pagination:{
            totalItems: 0,
            totalPages: 0,
            currentPage: 0,
            perPage:PER_PAGE
          }
        }
        case GET_MSG_TEMPLATE:
          return {
            ...state,
            msgTemplate: action.payload,
          }
      default:
        return state;
    }
  };
  